import { ERROR_MESSAGES } from "constants/errors";

const formatErrorMessage = (field, code) => {
  const formatter = ERROR_MESSAGES[code];
  if (!formatter) {
    return '알 수 없는 오류';
  }
  return formatter(field);
};

export const parseErrors = (response) => {
  const errors = response?.data?.errors;

  if (!errors) {
    return [{
      field: null,
      code: null,
      message: '알 수 없는 오류',
    }]
  }

  const parsedErrors = [];
  for (const [field, codes] of Object.entries(errors)) {
    for (const code of codes) {
      parsedErrors.push({
        field,
        code,
        message: formatErrorMessage(field, code),
      });
    }
  }

  return parsedErrors;
};

export const parseFieldError = (response) => {
  const errors = response?.data?.errors;
  if (!errors) return {};

  const parsedFieldError = {};
  Object.entries(errors).forEach(([field, codes]) => {
    const code = codes[0];
    parsedFieldError[field] = formatErrorMessage(field, code);
  });

  return parsedFieldError;
};

export const parseFieldErrors = (response) => {
  const errors = response?.data?.errors;
  if (!errors) return {};

  const parsedFieldErrors = {};
  Object.entries(errors).forEach(([field, codes]) =>  {
    parsedFieldErrors[field] = codes.map((code) => ({
      code,
      message: formatErrorMessage(field, code),
    }));
  });
  
  return parsedFieldErrors;
};